import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const PlusCircle = createSvgIcon(
  () => (
    <path d="M24.2188 0C10.8398 0 0 10.8398 0 24.2188C0 37.5977 10.8398 48.4375 24.2188 48.4375C37.5977 48.4375 48.4375 37.5977 48.4375 24.2188C48.4375 10.8398 37.5977 0 24.2188 0ZM38.2812 26.9531C38.2812 27.6367 37.6953 28.125 37.1094 28.125H28.125V37.1094C28.125 37.793 27.5391 38.2812 26.9531 38.2812H21.4844C20.8008 38.2812 20.3125 37.793 20.3125 37.1094V28.125H11.3281C10.6445 28.125 10.1562 27.6367 10.1562 26.9531V21.4844C10.1562 20.8984 10.6445 20.3125 11.3281 20.3125H20.3125V11.3281C20.3125 10.7422 20.8008 10.1562 21.4844 10.1562H26.9531C27.5391 10.1562 28.125 10.7422 28.125 11.3281V20.3125H37.1094C37.6953 20.3125 38.2812 20.8984 38.2812 21.4844V26.9531Z" />
  ),
  '0 0 49 49'
);
